const toastConfig = {
	duration: 5000,
	positionY: 'top',
	max: 1
};

export default toastConfig;
